import html2pdf from "html2pdf.js";

export async function savePdf(element: HTMLElement, filename: string = "document.pdf", opts: Partial<{
	scale: number;
	margin: number;
	format: string;
	orientation: "portrait" | "landscape";
}> = {}) {
	const blob: Blob = await html2pdf().set({
		html2canvas: { scale: opts.scale ?? 3, useCORS: true },
		jsPDF: {
			unit: "mm",
			format: opts.format ?? "letter",
			orientation: opts.orientation ?? "portrait",
		},
		margin: opts.margin ?? 10,
	}).from(element).outputPdf('blob');

	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}
